var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAppExcelDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1DAEA",
    d: "M15 1.3H7.046C6.47 1.3 6 1.769 6 2.346v4.356h9V1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B9C3D6",
    fillRule: "nonzero",
    d: "M6 17.532v4.322c0 .577.469 1.046 1.046 1.046H15v-5.368H6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C5CFE2",
    d: "M6 6.702h9v5.401H6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BEC8DA",
    fillRule: "nonzero",
    d: "M6 12.103h9v5.43H6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7F9FC",
    d: "M22.954 1.3H15v5.402h9V2.346c0-.576-.469-1.046-1.046-1.046z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C5CEE0",
    d: "M15 17.532V22.9h7.954c.577 0 1.046-.469 1.046-1.046v-4.321h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDF1F7",
    d: "M15 6.702h9v5.401h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4E9F2",
    d: "M15 12.103h9v5.43h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C5CEE0",
    fillRule: "nonzero",
    d: "M10.991 18.1H1.01A1.01 1.01 0 010 17.091V7.11C0 6.552.452 6.1 1.009 6.1h9.982A1.01 1.01 0 0112 7.109v9.982a1.01 1.01 0 01-1.009 1.009z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M3.484 9.1h1.432l1.161 2.252L7.305 9.1h1.337l-1.842 3 1.884 3h-1.41l-1.266-2.358L4.747 15.1H3.316l1.915-3.011z"
  }))));
}

export default SvgAppExcelDisabled;